import React from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { UserDetailsWrapper } from 'Components/UserManagement/UserDetailsWrapper'
import { UserManagementDetailsAddForm } from 'Containers/Form/UserManagement/UserDetails/Add'
import { createUser, updateUserById } from 'Reducers/Users/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { isClientRole } from 'Utils/Validators/roles'
import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'
import { CONFIG } from 'Config/config'
import { showReduxModal } from '../../../../Reducers/UI/actions'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'

const UserManagementDetailsAdd = ({
  createUser,
  updateUserById,
  uploadProfileImage,
  showReduxModal,
}) => {
  const history = useHistory()

  const renderBreadcrumbs = () => {
    return (
      <div>
        <StyledBreadcrumbs
          icon={<UserManagementIcon style={{ width: 24 }} />}
          breadcrumbs={[
            {
              label: 'User management',
              link: `${PATHS.main.dashboard}${PATHS.dashboard.userManagement}`,
            },
            { label: 'Add User' },
          ]}
        />
      </div>
    )
  }

  const handleUpdateAfterCreate = ({ id }, values) => {
    const callbacks = {
      onSuccess: userManagementDetailsAddFormSuccess,
    }

    uploadProfileImage(id, get(values, 'profilePicture[0]'), {
      onSuccess: imageUrl =>
        updateUserById(id, { profile_picture: imageUrl }, callbacks),
    })
  }

  const userManagementDetailsAddFormSubmit = values => {
    const payload = {
      first_name: values.firstName,
      last_name: values.lastName,
      mobile_phone: values.mobilePhone,
      email: values.email,
      password: values.password,
      business_number: values.businessNumber,
      role: values.role,
      status: values.status,
      is_verified: 1,
      profile_picture: undefined,
      subrole: null,
    }

    if (isClientRole(values.role)) {
      payload.client_id = values.clientId
    } else {
      payload.city_id = values.cityId
    }

    if (values.isCityManagerAssistant && CONFIG.USER_ROLE.CITY_MANAGER) {
      payload.subrole = CONFIG.SUBROLES.ASSISTANT
    }

    if (values.profilePicture) {
      const callbacks = {
        onSuccess: res => handleUpdateAfterCreate(res, values),
      }
      createUser(payload, callbacks)
    } else {
      const callbacks = {
        onSuccess: userManagementDetailsAddFormSuccess,
      }
      createUser(payload, callbacks)
    }
  }

  const userManagementDetailsAddFormSuccess = () => {
    showReduxModal({
      title: 'User successfully created',
      confirmLabel: 'OK',
      hideCancel: true,
      onConfirm: () =>
        history.push(
          `${PATHS.main.dashboard}${PATHS.dashboard.userManagement}`,
        ),
    })
  }

  return (
    <LayoutDashboard>
      {renderBreadcrumbs()}
      <UserDetailsWrapper>
        <UserManagementDetailsAddForm
          onSubmit={userManagementDetailsAddFormSubmit}
        />
      </UserDetailsWrapper>
    </LayoutDashboard>
  )
}

UserManagementDetailsAdd.propTypes = {
  createUser: PropTypes.func.isRequired,
  updateUserById: PropTypes.func.isRequired,
  uploadProfileImage: PropTypes.func.isRequired,
}

export default connect(
  null,
  {
    createUser,
    updateUserById,
    uploadProfileImage,
    showReduxModal,
  },
)(UserManagementDetailsAdd)
